/**
 * @description Card/Debit card model.
 */
export interface ICard {
  accountId?: number,
  type?: string,
  expiryMonth?: number,
  expiryYear: number,
  maskedAccountNumber: string,
  alias: string,
  isDisabled: boolean,
  accountNumber?: string,
  firstName?: string;
  lastName?: string;
  isExpired?: boolean;
  country?: string,
  street?: string,
  city?: string,
  stateProvince?: string,
  postCode?: string,
  cvn?: string,
  isDebit: boolean;
  isCvnRequired: boolean;
  paymentProcessor?: string;
  reEnterCardInfo?: boolean;
  billingAddress?: string;
  billingCity?: string;
  billingCountry?: string;
  billingPostalCode?: string;
  billingState?: string;
}

export enum ICardThreeDSecureType {
  directChallenge = 'directChallenge',
  secure3dsMethodBlock = 'secure3dsMethodBlock'
}

export enum ICardProcessor {
  fiserv = 'fiserv',
  Adyen = 'Adyen',
  WorldPay = 'WorldPay'
}



// WEBPACK FOOTER //
// ./src/model/models/payment-methods/card.interface.ts